var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M28.946 26.99l-7.666-7.814c1.346-1.756 2.178-3.922 2.178-6.3 0-5.744-4.672-10.416-10.416-10.416s-10.416 4.672-10.416 10.416c0 5.744 4.672 10.416 10.416 10.416 2.284 0 4.38-0.76 6.1-2.012l7.664 7.812c0.292 0.298 0.682 0.45 1.070 0.45 0.378 0 0.758-0.142 1.050-0.43 0.592-0.58 0.6-1.53 0.020-2.122zM5.626 12.876c0-4.088 3.328-7.416 7.416-7.416s7.416 3.328 7.416 7.416-3.328 7.416-7.416 7.416-7.416-3.328-7.416-7.416z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.fadcc9a0.svg";
export { ForwardRef as ReactComponent };